import fs from 'fs';
import os from 'os';
import path from 'path';

export function normalizeFilePath(rawPath: string): string {
  return rawPath.startsWith('/') || rawPath.startsWith('C:')
    ? rawPath
    : rawPath.startsWith('~')
      ? path.join(os.homedir(), rawPath.slice(1))
      : path.join(process.cwd(), rawPath);
}

export function verifyFileExists(filePath: string): boolean {
  return fs.existsSync(filePath);
}
